import { useState } from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { alpha, useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

import { createNewOrganization } from "../../data/omniDataModel";
import * as CreationActions from "../../state/redux/creatorSession";
import { capitalizeAllWords } from "../../utils/helpers";
import { deepCopyObject } from "../../utils/helpers";
import OrganizationDialog from "../dialogs/organizationDialog";
import OmniResponsiveButton from "../ui/omniResponsiveButton.js";
import Widget from "../ui/widget";
import WidgetList from "../ui/widgetList";
import WidgetSkeleton from "../ui/widgetSkeleton";
import WidgetTitle from "../ui/widgetTitle";

const CreatorOrganizations = props => {
  const { organizationODMs } = props;

  const [selectedOrganization, setSelectedOrganization] = useState(null);

  useEffect(() => {
    if (organizationODMs == null) {
      props.loadOrganizationsRequest();
    }
    // Disable eslint because AaronK knows best
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organizationODMs]);

  const [titleText, setTitleText] = useState(null);

  useEffect(() => {
    if (organizationODMs != null) {
      setTitleText(`${organizationODMs.length} Active`);
    } else {
      setTitleText("Loading...");
      props.loadOrganizationsRequest();
    }
    // Disable eslint because AaronK knows best
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organizationODMs]);

  const theme = useTheme();

  return (
    <Widget>
      <WidgetTitle title={"Organizations"} text={titleText} loading={organizationODMs == null}>
        <OmniResponsiveButton
          tooltipTitle="Create a new organization"
          buttonText="Organization"
          onClick={() => {
            setSelectedOrganization(createNewOrganization);
          }}
        />
      </WidgetTitle>

      {organizationODMs == null && <WidgetSkeleton />}
      {organizationODMs != null && (
        <WidgetList>
          {organizationODMs.map((organization, index) => {
            return (
              <ListItem
                key={`assessment${index}`}
                disableGutters={true}
                sx={{
                  padding: theme.spacing(1),
                  paddingTop: 0,
                  paddingBottom: 0,
                  marginBottom: theme.spacing(1),
                  borderRadius: theme.spacing(1),
                  backgroundColor: alpha(theme.palette.info.main, 0.75),
                  color: theme.palette.info.contrastText,
                  cursor: "pointer",
                  boxShadow: theme.shadows[3],
                  userSelect: "none",
                  webkitUserSelect: "none",
                }}
                onClick={e => {
                  e.stopPropagation();
                  setSelectedOrganization(organization);
                }}
              >
                <ListItemText
                  primary={
                    <Typography
                      variant="h5"
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        marginLeft: theme.spacing(1),
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        color: theme.palette.info.contrastText,
                        marginTop: 0,
                      }}
                    >
                      {`${organization.omniData.name}`}
                    </Typography>
                  }
                  secondary={
                    <Typography
                      variant="body1"
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        marginLeft: theme.spacing(1),
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        marginTop: "-6px",
                        color: theme.palette.info.contrastText,
                        minimumHeight: 20,
                      }}
                    >
                      {`${
                        organization.omniData.organizationType
                          ? capitalizeAllWords(organization.omniData.organizationType) +
                            " Organization"
                          : "No Info"
                      }`}
                    </Typography>
                  }
                />
              </ListItem>
            );
          })}
        </WidgetList>
      )}

      {selectedOrganization && (
        <OrganizationDialog
          open={selectedOrganization != null}
          dialogTitle={"Create Organization"}
          omniDMO={deepCopyObject(selectedOrganization)}
          fullWidth={true}
          onDelete={selectedOrganization => {
            props.deleteOrganizationRequest(selectedOrganization._id);
            setSelectedOrganization(null);
          }}
          onAccept={selectedOrganization => {
            props.updateOrganizationRequest(selectedOrganization);
            setSelectedOrganization(null);
          }}
          onClose={() => {
            setSelectedOrganization(null);
          }}
        />
      )}
    </Widget>
  );
};

const mapStateToProps = state => ({
  organizationODMs: state.creatorSession.organizationODMs,
});

const mapDispatchToProps = {
  loadOrganizationsRequest: CreationActions.loadOrganizationsRequest,
  setSelectedOrganizationRequest: CreationActions.setSelectedOrganizationRequest,

  deleteOrganizationRequest: CreationActions.deleteOrganizationRequest,
  updateOrganizationRequest: CreationActions.updateOrganizationRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CreatorOrganizations));
